import { Inject, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { ISubstrate } from '../insecta.models';
import { DictionaryCacheService } from '../dictionary-cache.service';
import { HttpClient } from '@angular/common/http';
import { SETTINGS, Settings } from '../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class SubstrateAdminService extends InsectaServiceBase {
  constructor(
    private http: HttpClient,
    @Inject(SETTINGS) settings: Settings,
    private dictionaryCache: DictionaryCacheService
  ) {
    super(http, settings);
  }
  public addSubstrate(substrate: ISubstrate): Observable<string> {
    return this.post<string>(`/admin/substrates`, `v1`, {
      name: substrate.name,
      isActive: substrate.isActive,
      username: substrate.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('substrate')));
  }

  public getSubstrate(id: string): Observable<ISubstrate> {
    return this.get<ISubstrate>(`/admin/substrates/${id}`, 'v1');
  }

  public getSubstrates(includeInActive: boolean | null | undefined): Observable<ISubstrate[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<ISubstrate[]>(`/admin/substrates`, 'v1').pipe(
      map((results) => [...results].filter((x: ISubstrate) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: ISubstrate, b: ISubstrate) =>
          a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1
        )
      )
    );
  }

  public getSubstratesAll(): Observable<ISubstrate[]> {
    return this.getSubstrates(true);
  }

  public updateSubstrate(substrate: ISubstrate): Observable<any> {
    return this.put<ISubstrate>(`/admin/substrates/${substrate.id}`, `v1`, {
      id: substrate.id,
      name: substrate.name,
      isActive: substrate.isActive,
      username: substrate.actionBy
    }).pipe(tap(() => this.dictionaryCache.invalidate('substrate')));
  }
}
